import { ListDivider } from '@hb/shared'

export const monthDivider: ListDivider = {
  _type: 'divider',
  type: 'month',
  propPath: 'edd',
}
